import axios from '../axiosConfig';

// -----------------------------
// Conditions API Service
// -----------------------------

export interface Condition {
  value: string;      // e.g., "!=", ">", ">=", "<", "<=", "=="
  displayName: string; // e.g., "not equals", "higher than", etc.
}

let cachedConditions: Condition[] | null = null;

/**
 * Fetches all available conditions from the API.
 * Results are cached to avoid repeated API calls.
 */
export async function fetchConditions(): Promise<Condition[]> {
  if (cachedConditions) {
    return cachedConditions;
  }

  try {
    const { data } = await axios.get<Condition[]>('v1/Condition');
    cachedConditions = Array.isArray(data) ? data : [];
    return cachedConditions;
  } catch (error) {
    console.error('Failed to fetch conditions:', error);
    return [];
  }
}

/**
 * Clears the cached conditions data.
 * Useful when you need to force a refresh.
 */
export function clearConditionsCache(): void {
  cachedConditions = null;
}

/**
 * Gets a condition by its value.
 */
export function getConditionByValue(conditions: Condition[], value: string): Condition | undefined {
  return conditions.find(c => c.value === value);
}

/**
 * Gets the display name for a condition value.
 */
export function getConditionDisplayName(conditions: Condition[], value: string): string {
  const condition = getConditionByValue(conditions, value);
  return condition?.displayName || value;
}

